import { render, staticRenderFns } from "./dyAlert.vue?vue&type=template&id=46b1317c&scoped=true"
import script from "./dyAlert.vue?vue&type=script&lang=js"
export * from "./dyAlert.vue?vue&type=script&lang=js"
import style0 from "./dyAlert.vue?vue&type=style&index=0&id=46b1317c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1317c",
  null
  
)

export default component.exports